<script lang="ts">
  import { fade } from "svelte/transition";
  let { isShortcutMode, hideOverlay } = $props();
</script>

{#if isShortcutMode}
  <div class="fixed bottom-6 right-6 z-50 dark:bg-zinc-800 p-3 shadow-lg" transition:fade={{ duration: 150 }}>
    <div class="mb-1 text-center text-base font-semibold text-theme-text-primary">Keyboard Shortcuts</div>

    <div class="text-sm text-theme-text-secondary mb-2 px-1">Quickly execute actions with on-screen hotkeys</div>

    <div class="flex items-end justify-between rounded px-1 py-1 text-sm">
      <button onclick={hideOverlay()} class="text-theme-text-primary font-medium">Hide this overlay</button>
      <div class="flex items-end gap-1.5">
        <span class="flex h-5 items-center px-1 bg-yellow-400 text-black text-xs">alt</span>
        <span class="h-5 flex items-end text-theme-text-secondary text-xs">or</span>
        <span class="flex h-5 items-center px-1 bg-yellow-400 text-black text-xs">⌥</span>
      </div>
    </div>
  </div>
{/if}
